import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from '@mui/styles/makeStyles';
// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components

import sectionTextStyle from "styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle.js";
import profilePageStyle from "styles/jss/nextjs-material-kit-pro/pages/profilePageStyle.js";
import Button from "components/CustomButtons/Button.js";
import Tooltip from "@mui/material/Tooltip";
import Add from "@mui/icons-material/Add";


import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';


const style = {
  ...profilePageStyle,
  ...sectionTextStyle,
};
const useStyles = makeStyles(style);
export default function SectionText() {
  const classes = useStyles();
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );

  return (
    <div className={classes.section} style = {{ paddingTop : "0px"}} >
      <GridContainer  alignItems="center" spacing={4} style = {{ paddingTop : "0px" }} >
          <GridItem xs={12} sm={10} md={10} lg={12} >

          <h2 className={classes.title}>Actual examples of our analytical approach & expertise</h2>

          </GridItem> 

          
          <GridItem xs={12} sm={12} md={12} className={classes.section} style={{paddingTop:"10px"}}>
            
              <GridContainer > 
                
                <GridItem xs={12} sm={4} md={4}>
                  <img
                    src="/img/sections/services/google-ads-services/shopping-ads.webp"
                    alt="..."
                    className={imgClasses}
                  />
                  <div style={{textAlign:"center"}}><i><br />Google Shopping Ads</i></div>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <img
                    src="/img/sections/services/google-ads-services/google-ads-dashboard.webp"
                    alt="..."
                    className={imgClasses}
                  />
                  <div style={{textAlign:"center"}}><i><br />Google Ads Reports in Data Studio</i></div>
                </GridItem>
                <GridItem xs={12} sm={4} md={4}>
                  <img
                    src="/img/sections/services/google-ads-services/sheets-reporting-google-ads.webp"
                    alt="..."
                    className={imgClasses}
                  />
                  <div style={{textAlign:"center"}}><i><br />Detailed Ads Tracking in Google Sheets</i></div>

                  <br></br>
                  <br></br>
                </GridItem>
              </GridContainer>
            </GridItem>
      </GridContainer>
        
    </div>

    
    
  );
}